<template>
  <div class="u-text-align-center u-locked-view u-padding-top u-padding-bottom">
    <img width="125" src="@/assets/images/locked.svg" alt="locked svg" />

    <div class="u-margin-top">{{ $t("common.lockedView") }}</div>
    <div class="u-margin-top-small">
      <div>
        {{ $t("common.lockedViewText") }}
      </div>
      <div class="u-margin-top">
        <router-link :to="{ name: 'app-start' }">
          <Button variant="primary">
            <i class="icofont-home"></i> {{ $t("common.goHome") }}
          </Button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "./Button.vue";
export default {
  components: { Button },
};
</script>

<style></style>
